import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './IconCloseChevron.module.css';

const IconCloseChevron = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg className={classes} width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.60275 12.5105L0 11.9078L5.65275 6.25525L0 0.602751L0.60275 0L6.25525 5.65275L11.9078 0L12.5105 0.602751L6.85775 6.25525L12.5105 11.9078L11.9078 12.5105L6.25525 6.85775L0.60275 12.5105Z" fill="#1E1E1E"/>
    </svg>
  );
};

const { string } = PropTypes;

IconCloseChevron.defaultProps = {
  className: null,
  rootClassName: null,
};

IconCloseChevron.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconCloseChevron;
